import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, timer} from 'rxjs';
import {takeWhile} from 'rxjs/operators';
import {UserService} from '../../services/user/user.service';
import {AlertService} from '../../services/alert/alert.service';
import {RoutingStateService} from '../../services/routing-state.service';

@Component({
    selector: 'app-hhg-rates-view',
    templateUrl: './hhg-rates-view.component.html',
    styleUrls: ['./hhg-rates-view.component.css'],
    standalone: false
})
export class HhgRatesViewComponent implements OnInit {
  activeTab: string;
  showViewRate: Boolean = true;
  observer$ = new BehaviorSubject(true);
  isRateFilingClosed$ =  new BehaviorSubject(false);
  closingDate: number = null;

  constructor(private userService: UserService,
              private alertService: AlertService,
              private routing: RoutingStateService) {}

  /**
   * @description listens to changes in tab selection and lazy loades the component according to the tab heading.
   * @param $event: tab directive data including heading.
   */
  onSelectTab($event) {
    this.routing.addCrumbsFromTabs('1');
    this.showViewRate = false;
    if ($event.heading === 'HHG View Rates') {
      this.activeTab = 'zero';
      this.routing.addCrumbsFromTabs('hhgView');
    } else if ($event.heading === 'HHG Add Rates') {
      this.activeTab = 'one';
      this.routing.addCrumbsFromTabs('hhgAdd');
    } else if ($event.heading === 'HHG Edit Rates') {
      this.activeTab = 'two';
      this.routing.addCrumbsFromTabs('hhgEdit');
    } else if ($event.heading === 'HHG Global Update') {
      this.activeTab = 'three';
      this.routing.addCrumbsFromTabs('hhgGlobal');
    } else if ($event.heading === 'HHG Upload Rate File') {
      this.activeTab = 'four';
      this.routing.addCrumbsFromTabs('hhgUpload');
    } else if ($event.heading  === 'HHG Template Download') {
      this.activeTab = 'five';
      this.routing.addCrumbsFromTabs('hhgTemplate');
    }
  }

  ngOnInit(): void {
    timer(1000, 1000)
      .pipe(takeWhile(() => !this.isRateFilingClosed$.value))
      .subscribe(val => {
        this.userService.isRateFilingClosed()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.isRateFilingClosed$.next(res);
            if (res) {
              this.alertService.warn('Rate Filing Window has been closed!');
            }
          });
      });
  }
}
